module.exports = __webpack_public_path__ + "img/esmeralda-hotel-4.fde98eed.jpg";